import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-accent/5 py-20 lg:py-32">
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
      <div className="relative max-w-7xl mx-auto px-6 text-center">
        <div className="max-w-4xl mx-auto space-y-8">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-medium">
            <Icon name="Sparkles" size={16} />
            <span>AI-Powered Prompt Generation</span>
          </div>

          {/* Main Headline */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-text-primary leading-tight">
            Transform Your Ideas Into
            <span className="block text-primary">Perfect Prompts</span>
          </h1>

          {/* Subheadline */}
          <p className="text-xl md:text-2xl text-text-secondary max-w-3xl mx-auto leading-relaxed">
            Harness the power of AI to generate intelligent, categorized prompts for marketing, legal, technical, and creative projects. Get three tailored suggestions with every request.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-8">
            <Link to="/prompt-generator">
              <Button 
                variant="default" 
                size="lg" 
                iconName="Zap" 
                iconPosition="left"
                className="px-8 py-4 text-lg font-semibold hover-scale"
              >
                Start Generating Prompts
              </Button>
            </Link>
            <Link to="/pricing-plans">
              <Button 
                variant="outline" 
                size="lg" 
                iconName="ArrowRight" 
                iconPosition="right"
                className="px-8 py-4 text-lg font-medium"
              >
                View Pricing
              </Button>
            </Link>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-8 pt-12 text-sm text-text-secondary">
            <div className="flex items-center space-x-2">
              <Icon name="Shield" size={16} color="var(--color-success)" />
              <span>Enterprise Security</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Zap" size={16} color="var(--color-warning)" />
              <span>Instant Generation</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Users" size={16} color="var(--color-accent)" />
              <span>10,000+ Users</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;